function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'rosa-bund': 'rgb(255, 0, 128)','celeste': 'rgb(0, 170, 228)','blanco': 'rgb(255, 255, 255)','burgundy': 'rgb(89, 34, 29)','navy': 'rgb(30, 45, 60)','aqua-green': 'rgb(74, 115, 121)','dark-navy': 'rgb(63, 60, 82)','havana': 'rgb(235, 198, 146)','red': 'rgb(196, 72, 81)','pink-red': 'rgb(218, 65, 91)','gold': 'rgb(219, 194, 146)','green-bottle': 'rgb(37, 73, 77)','blue': 'rgb(65, 79, 139)','aquamarine': 'rgb(46, 112, 154)','steel': 'rgb(72, 71, 72)','marino': 'rgb(30, 45, 60)',};

    this.images = {'al-gusto': 'url("//www.bundcompany.mx/cdn/shop/files/eye-dropper-solid_68x.png?v=5730675346818446104")','otro': 'url("//www.bundcompany.mx/cdn/shop/files/eye-dropper-solid_68x.png?v=5730675346818446104")',};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

window.theme.swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  window.theme.swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);
